import React from "react"

import InputsWithoutValidate from "Components/UI/Molecules/InputsWithoutValidate"
import BasicTable from "Components/UI/Atoms/BasicTable"
import { IconButton } from "@material-ui/core"
import { Delete } from "@material-ui/icons"

const Step4 = (props) => { 
  const { initValues, handleChange, setInitValues } = props
  const field = [
    {
      class: "textfield",
      label: "Dominio / Nº Siniestro",
      name: "dominio",
      value: initValues.vehicle ? initValues.vehicle.dominio_siniestro : "",
      disabled: true,
      xs: 12,
      sm: 12,
    },
    {
      class: "textfield",
      label: "Vehículo",
      name: "vehiculo",
      value: initValues.vehicle
        ? `${initValues.vehicle.marca} ${initValues.vehicle.modelo} ${initValues.vehicle.año}`
        : "",
      disabled: true,
      xs: 12,
      sm: 12,
    },
    {
      class: "textfield",
      label: "Observación",
      name: "observaciones_estacion_cero",
      value: initValues.vehicle ? initValues.vehicle.observaciones_estacion_cero : "", 
      onChange: (e) => handleChange("observaciones_estacion_cero", e.target.value),
      xs: 12,
      sm: 12,
      multiline: true,
      rows: 4,
    },
  ]

  const newProductsToCreate = initValues.products.filter((p) => {
    const isLengthChanged = p.items.length !== p.itemsOriginal.length
 
    return isLengthChanged && p.checked
  })

  const countNewItems = (items, itemsOriginal) => {
    return items
      .slice(itemsOriginal.length) 
      .filter(item => item.checked === true)
      .length
  }

  const getRemovedItems = (product) => {
    return product.items.filter((item, index) => {
      const originalItem = product.itemsOriginal[index];
      return originalItem && originalItem.checked && !item.checked;
    })
  }

  const removedProducts = initValues.products.filter((product) => {
    const removedItems = getRemovedItems(product)
    return removedItems.length > 0
  })

  const countRemovedItems = (product) => {
    return getRemovedItems(product).length
  }

  const iconDelete = (productoId) => (
    <IconButton 
      onClick={(event) => {
        event.stopPropagation()
        setInitValues((prev) => ({
          ...prev,
          products: prev.products.map((p) =>
            p.id === productoId
              ? {
                  ...p,
                  checked: true,
                  items: p.items?.map((item) => ({
                    ...item,
                    checked: true,
                  })) || [],
                }
              : p
          ),
        }))
      }} 
      style={{ padding: "0px" }}
    >
      <Delete />
    </IconButton>
  )

  const iconDelete2 = (productoId) => (
    <IconButton
      onClick={(event) => {
        event.stopPropagation()

        setInitValues((prev) => ({
          ...prev,
          products: prev.products.map((p) => {
            if (p.id !== productoId) return p

            const items = p.items || []
            const originalItems = p.itemsOriginal || []

            const hasUndefined = items.some((item) => item.estado === undefined)

            if (hasUndefined) {
              return {
                ...p,
                checked: originalItems.length > 0,
                items: originalItems.map((item) => ({
                  ...item,
                  checked: originalItems.length > 0,
                })),
              }
            }

            return {
              ...p,
              checked: false,
              items: originalItems.map((item) => ({
                ...item,
                checked: false,
              })),
            }
          }),
        }))
      }}
      style={{ padding: 0 }}
    >
      <Delete />
    </IconButton>
  )

  return (
    <div
      style={{
        maxHeight: "550px",
        overflowY: "auto",  
        paddingTop: "5px",
        paddingRight: "8px", 
      }}
    >
      <InputsWithoutValidate fields={field} spacing={2} />
      <div style={{ marginTop: "10px" }}>
        <BasicTable
          size={"small"}
          stylePaper={{ height: "auto", overflowY: "scroll", marginBottom: "15px" }}
          col={[
            {
              title: `Nuevas piezas a crear: ${
                newProductsToCreate.length
              }`,
              style: { width: "85%", textAlign: "center", color: "#5eb743" },
            },
            { title: "", style: { width: "10%" } },
          ]}
          rows={newProductsToCreate.map((row) => {
              return {
                codigo: (
                  <div style={{ color: "#515050", textAlign: "start" }}>
                    {row.producto}{" "}
                    <span style={{ color: "#888", fontSize: "0.9em" }}>
                      ({countNewItems(row.items, row.itemsOriginal)})
                    </span>
                  </div>
                ),
                action: iconDelete2(row.id),
              }
            })}
        />
      </div>
      <div>
        <BasicTable
          size="small"
          stylePaper={{ height: "auto", overflowY: "scroll" }}
          col={[
            {
              title: `Piezas colocadas a eliminar: ${removedProducts.length}`,
              style: { width: "85%", textAlign: "center", color: "#b14b4b" },
            },
            { title: "", style: { width: "10%" } },
          ]}
          rows={removedProducts.map((row) => ({
            codigo: (
              <div style={{ color: "#515050", textAlign: "start" }}>
                {row.producto}{" "}
                <span style={{ color: "#888", fontSize: "0.9em" }}>
                  ({countRemovedItems(row)})
                </span>
              </div>
            ),
            action: iconDelete(row.id),
          }))}
        />
      </div>
    </div>
  )
}

export default Step4